import React__default, { forwardRef, createRef, useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import dayjs from 'dayjs';
import useTranslation from '../../../Hooks/useTranslation.js';
import fallbackDateRange from '../../../../_Translations/generated/date-range-input.en.t.json.js';
import Keys from '../../../../_Translations/generated/date-range-input.en.t.json.keys.js';
import { FontAwesomeIcon } from '../../../../../../../node_modules/.pnpm/@fortawesome_react-fontawesome@0.2.2_@fortawesome_fontawesome-svg-core@6.7.2_react@19.0.0/node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faCalendarAlt } from '../../../../../../../node_modules/.pnpm/@fortawesome_free-solid-svg-icons@6.7.2/node_modules/@fortawesome/free-solid-svg-icons/index.mjs.js';

const validateKeyboardInput = (config) => {
    let message = '';
    let date = undefined;
    const dayJsParsed = dayjs.utc(config.inputValue, config.format, true);
    // first check if entered date is valid to the given format
    if (!dayJsParsed.isValid()) {
        message = config.translateFn(config.format ? Keys.invalidDateWithFormat : Keys.invalidDateFormat, {
            format: config.format
        });
    }
    else {
        date = dayJsParsed.toDate();
    }
    // validate minDate if set
    if (config.minDate && dayjs(config.minDate).isAfter(dayJsParsed)) {
        message = config.translateFn(Keys.invalidMinDate, {
            minDate: dayjs(config.minDate).format(config.format)
        });
        date = undefined;
    }
    // validate maxDate if set
    if (config.maxDate && dayjs(config.maxDate).isBefore(dayJsParsed)) {
        message = config.translateFn(Keys.invalidMaxDate, {
            maxDate: dayjs(config.maxDate).format(config.format)
        });
        date = undefined;
    }
    return { message, date };
};
const DateWithKeyboardSupportInner = (props, ref) => {
    const { onClick, onInputChange, date, format, placeholder, dataTestId, minDate, maxDate, inputClassName, useFormValidation, setValueToNullWhenFormatIsIncorrect, noInitialValueInput } = props;
    const inputRef = createRef();
    const [isInitialized, setIsInitialized] = useState(noInitialValueInput ? false : true);
    useEffect(() => {
        if (isInitialized && date) {
            if (inputRef && inputRef.current) {
                inputRef.current.value = dayjs(date).format(format);
            }
        }
    }, [date, isInitialized]);
    const [errorMsg, setErrorMsg] = useState('');
    const { t } = useTranslation('date-range-input', fallbackDateRange, Keys);
    return (React__default.createElement("div", { "data-testid": dataTestId },
        React__default.createElement("div", { className: "d-flex" },
            React__default.createElement("div", { className: "mr-2 flex-column flex-grow-1" },
                React__default.createElement("input", { type: "text", className: `iso__date-picker__input  ${inputClassName ? inputClassName : ''}`, placeholder: placeholder, defaultValue: noInitialValueInput ? '' : date ? dayjs(date).format(format) : '', ref: inputRef, onBlur: val => {
                        setIsInitialized(true);
                        if (!val.target.value || val.target.value.trim() === '') {
                            return;
                        }
                        if (!!onInputChange && setValueToNullWhenFormatIsIncorrect) {
                            const parsedDayJs = dayjs.utc(val.target.value, format, true);
                            if (!parsedDayJs.isValid()) {
                                onInputChange(null);
                            }
                        }
                        // using form validation (DatePickerWrapper & FormDatePicker) will skip DatePicker's own validation
                        if (!!onInputChange && useFormValidation) {
                            const parsedDayJs = dayjs.utc(val.target.value, format, true);
                            if (parsedDayJs.isValid()) {
                                onInputChange(parsedDayJs.toDate());
                            }
                            return;
                        }
                        const checkInputValidity = validateKeyboardInput({
                            translateFn: t,
                            inputValue: val.target.value,
                            format,
                            minDate,
                            maxDate
                        });
                        if (!!onInputChange && checkInputValidity.message === '' && checkInputValidity.date) {
                            setErrorMsg('');
                            onInputChange(checkInputValidity.date);
                        }
                        if (checkInputValidity.message !== '') {
                            setErrorMsg(checkInputValidity.message);
                        }
                    } })),
            React__default.createElement(Button, { onClick: () => {
                    setIsInitialized(true);
                    if (onClick) {
                        onClick();
                    }
                }, ref: ref, className: "iso__date-picker__keyboardSupportButton" },
                React__default.createElement(FontAwesomeIcon, { icon: faCalendarAlt }))),
        !useFormValidation && React__default.createElement("span", { className: "validation-error" }, errorMsg)));
};
const DateWithKeyboardSupport = forwardRef(DateWithKeyboardSupportInner);

export { DateWithKeyboardSupport, DateWithKeyboardSupportInner };
//# sourceMappingURL=DateWithKeyboardSupport.js.map
